// src/index.js
//
// React app entry point.
//
// Responsibilities:
//  - Create the React 18 root.
//  - Wrap the app with AuthProvider so auth state is available everywhere.
//  - Load global CSS (and vendor styles like Bootstrap).
//
// Notes:
//  - React.StrictMode in React 18 intentionally double-invokes some lifecycle
//    patterns in development to surface side effects. This is DEV-only.
//  - Routing is configured in App.js (BrowserRouter lives there).

import React from "react";
import ReactDOM from "react-dom/client";

import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";

import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import reportWebVitals from "./reportWebVitals";

const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

/**
 * Web vitals logging:
 * - Helpful during performance tuning.
 * - Usually too noisy for normal dev work, and should be OFF in production.
 *
 * Enable by setting:
 *   REACT_APP_LOG_WEB_VITALS=true
 */
const shouldLogWebVitals =
  process.env.NODE_ENV !== "production" &&
  String(process.env.REACT_APP_LOG_WEB_VITALS).toLowerCase() === "true";

if (shouldLogWebVitals) {
  reportWebVitals((metric) => {
    // eslint-disable-next-line no-console
    console.log("[WebVitals]", metric);
  });
}
